import React, { useEffect, useState } from "react";
import {useAuth} from "../utils/AuthContext";
import {useNavigation} from "../utils/NavigationContext";
import {
  Calendar,
  Video,
  Sliders,
  PlusCircle,
  Layers,
  LogOut,
  Receipt,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const Sidebar = ({ activeSidebarItem, onSidebarItemClick }) => {
  const navigate = useNavigate();
  const { userRole } = useAuth();
  const { startNavigation } = useNavigation();

  const handleLogout = async () => {
    try {
      localStorage.removeItem("userRole");
      document.cookie = "token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
      window.location.href = "/login";
    } catch (error) {
      console.log("Unable to logout");
    }
  };

  const sidebarItems = [
    { id: "calendar", icon: Calendar, label: "Calendar", path: "/dashboard" },
    { id: "videos", icon: Video, label: "All Videos", path: "/videos" },
    { id: "add", icon: PlusCircle, label: "Add Video", path: "/add-video" },
   
    {
      id: "video-style",
      icon: Sliders,
      label: "Video Style",
      path: "/video-style",
    },
    {
      id: "story-type",
      icon: Layers,
      label: "Story Type",
      path: "/story-type",
    },
  ];
 
  
  

  if (userRole === "ADMIN") {
    sidebarItems.push({
      id: "purchase-order",
      icon: Receipt,
      label: "Purchase Order",
      path: "/purchase-order",
    });
  }

  return (
    <div className="w-64 bg-white shadow-lg flex flex-col">
      <div className="p-4 border-b border-gray-200">
        <h2 className="text-xl font-bold text-gray-900">Content Planner</h2>
      </div>

      <nav className="flex-1 pt-4">
        {sidebarItems.map((item) => (
          <button
            key={item.id}
            onClick={() => {
              startNavigation(item.path);
              onSidebarItemClick(item.id, item.path);
            }}
            className={`w-full flex items-center px-4 py-3 text-sm font-medium transition-colors ${
              activeSidebarItem === item.id
                ? "bg-blue-50 text-blue-600"
                : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
            }`}
          >
            <item.icon className="mr-3 h-5 w-5" />
            {item.label}
          </button>
        ))}
      </nav>

      <button
        onClick={handleLogout}
        className="flex items-center px-5 py-3 text-sm font-semibold text-white bg-red-600 rounded-lg shadow hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-all mt-auto mb-4 mx-4"
      >
        <LogOut className="mr-2 h-5 w-5" />
        LogOut
      </button>
    </div>
  );
};

export default Sidebar;
